import {LoginLogoutView} from "./login-logout.view";
import {ReactKeycloakProvider, useKeycloak} from "@react-keycloak/web";
import React, {useEffect} from "react";
import PropTypes from "prop-types";
import Keycloak from "keycloak-js";
import {usePrincipal} from "@betrue/front/profile";
import {KEYCLOAK_CONFIG} from "../config/front-config";


export function LoginLogoutContainer({loginLabel, logoutLabel}:
                                {
                                  loginLabel?: string,
                                  logoutLabel?: string,
                                  children?: React.ReactNode
                                }) {
  const {keycloak, initialized} = useKeycloak()
  const [principal, setPrincipal] = usePrincipal()
  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated) {
        setPrincipal({
          sub: keycloak.subject,
          token: keycloak.token,
          refreshToken: keycloak.refreshToken,
          parsedToken: keycloak.tokenParsed
        })

      } else {
        //keycloak.login()
      }
    }

  }, [
    keycloak,
    initialized])

  const login = () => {
    localStorage.clear()
    keycloak.login({idpHint: KEYCLOAK_CONFIG().idpHint})
  }

  const logout = () => {
    localStorage.clear()
    keycloak.logout()
  }

  return (
    <LoginLogoutView login={login}
                     logout={logout}
                     principal={principal}
                     loginLabel={loginLabel ? loginLabel : 'Login'}
                     logoutLabel={logoutLabel ? logoutLabel : 'Logout'}
                     authenticated={keycloak.authenticated}/>

  );
}

export const LoginLogoutContainerWithKeycloakProvider = ({loginLabel, logoutLabel}:
                                                           { loginLabel?: string, logoutLabel?: string }) => {

  const keycloak = Keycloak(
    {
      url: KEYCLOAK_CONFIG().authServerUrl,
      realm: KEYCLOAK_CONFIG().realm,
      clientId: KEYCLOAK_CONFIG().clientId
    }
  )

  return <ReactKeycloakProvider authClient={keycloak}
                                initOptions={KEYCLOAK_CONFIG().init}>
    <LoginLogoutContainer logoutLabel={logoutLabel} loginLabel={loginLabel}/>
  </ReactKeycloakProvider>

}

LoginLogoutContainerWithKeycloakProvider.propTypes = {
  logoutLabel: PropTypes.string,
  loginLabel: PropTypes.string
};
